import { JoynV2Api } from '../api/joyn/JoynApi';

export default new (class AuthUserRepository {
  getProfile = () => JoynV2Api.get(`/profile/me`);
})();
